export default __webpack_public_path__ + "static/media/cebuana.11cc4451.JPG";